import { render } from "./CanvasArea.vue?vue&type=template&id=6ffab548"
import script from "./CanvasArea.vue?vue&type=script&lang=js"
export * from "./CanvasArea.vue?vue&type=script&lang=js"
script.render = render

export default script